import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/free.css'
import './assets/css/common.css'
import VConsole from 'vconsole';

Vue.config.productionTip = false
import { NavBar,Search,Toast,Tab, Tabs,List,PullRefresh,Button,Collapse, CollapseItem,Dialog,Notify,IndexBar, IndexAnchor,Icon,Popup,Field,Loading,Divider,ImagePreview,Lazyload,Image as VanImage  } from 'vant';


Vue.use(Lazyload,{
  lazyComponent: true,
});
Vue.use(VanImage);
Vue.use(Dialog);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Search);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Notify);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Loading);
Vue.use(Divider);
Vue.use(ImagePreview);

// 懒加载
import "vue-virtual-scroller/dist/vue-virtual-scroller.css" // 引入它的 css
import VueVirtualScroller from "vue-virtual-scroller" // 引入它
Vue.use(VueVirtualScroller) // use 它

// // // 移动端调试插件
// const vConsole = new VConsole()
// Vue.use(vConsole);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
